import Marquee from "react-fast-marquee";
import { INDUSTRIES } from "@/lib/site";

export const IndustriesMarquee = () => (
  <section className="border-y border-white/10 py-10 bg-black overflow-hidden" data-testid="industries-marquee">
    <Marquee gradient={false} speed={40} pauseOnHover>
      {INDUSTRIES.concat(INDUSTRIES).map((i, idx) => (
        <span key={idx} className="font-display text-4xl md:text-6xl tracking-tighter text-white/20 mx-16">
          {i} <span className="text-[#FF5722] mx-4">◆</span>
        </span>
      ))}
    </Marquee>
  </section>
);
